/* WI cart — discount visibility v6: sentinel codes (clear/null) filtered from cookie, storage AND cart; auto-removed from cart */
(function(){
  var root = document.querySelector('wi-cartdrawer'); if(!root) return;
  function wiCookie(n){ var m=document.cookie.match(new RegExp('(?:^|; )'+n+'=([^;]*)')); return m?decodeURIComponent(m[1]):''; }
  function isSentinel(c){ c=(c||'').trim().toLowerCase(); return !c || c==='clear' || c==='null' || c==='undefined'; }
  function normCode(v){ v=(v||'').trim(); return isSentinel(v) ? '' : v; }
  function clearPending(code){
    try{ var p=sessionStorage.getItem('wi_dc'); if(!code || (p&&p.toUpperCase()===code)) sessionStorage.removeItem('wi_dc'); }catch(e){}
    var ck=wiCookie('discount_code');
    if(!code || (ck&&ck.toUpperCase()===code)) document.cookie='discount_code=; Max-Age=0; path=/';
  }
  function pendingCode(){
    var v=null; try{ v=sessionStorage.getItem('wi_dc'); }catch(e){}
    return normCode(v) || normCode(wiCookie('discount_code'));
  }
  function eur(c){ return '€'+(c/100).toFixed(2).replace('.',','); }
  async function wiCartJson(){ try{ return await (await fetch('/cart.js',{headers:{'Accept':'application/json'}})).json(); }catch(e){ return null; } }
  function wiCodesOf(c){ return ((c&&c.discount_codes)||[]).map(function(d){return (d.code||'').toUpperCase();}).filter(function(x){return !isSentinel(x);}); }
  var cleaning=false;
  async function cleanSentinels(cart){
    if(cleaning) return false;
    var all=((cart&&cart.discount_codes)||[]).map(function(d){return (d.code||'').toUpperCase();});
    var good=all.filter(function(x){return !isSentinel(x);});
    if(all.length===good.length) return false;
    cleaning=true;
    try{ await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:good.join(',')})}); }catch(e){}
    clearPending();
    cleaning=false;
    return true;
  }
  async function wiApplyDiscount(code){
    code=normCode(code); if(!code) return {ok:false};
    try{
      var c=await wiCartJson(); var codes=wiCodesOf(c);
      if(codes.indexOf(code.toUpperCase())<0) codes.push(code.toUpperCase());
      var r=await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:codes.join(',')})});
      if(r.ok){
        var cart=await r.json();
        var hit=(cart.discount_codes||[]).find(function(d){return (d.code||'').toUpperCase()===code.toUpperCase();});
        if(hit) return {ok:true,applicable:hit.applicable!==false};
      }
    }catch(e){}
    try{ await fetch('/discount/'+encodeURIComponent(code)); return {ok:true,applicable:null}; }catch(e){ return {ok:false}; }
  }
  function wiMsg(txt,cls){
    var m=document.querySelector('.WI_discountMsg'); if(!m) return;
    if(!txt){ m.hidden=true; return; }
    m.textContent=txt; m.className='WI_discountMsg '+(cls||''); m.hidden=false;
  }
  var renderBusy=false;
  function chipHTML(code,state,note,pendingAttr){
    var mark = state==='ok' ? '✓' : '!';
    var cls = state==='ok' ? 'is-ok' : 'is-warn';
    var h='<span class="WI_discountChip '+cls+'" data-wi-js="1">'+mark+' '+code+'<button type="button" class="WI_discountRemove" data-code="'+code+'"'+(pendingAttr?' data-pending="1"':'')+' aria-label="Rabattcode entfernen">×</button></span>';
    if(note) h+='<span class="WI_discountChipNote" data-wi-js="1">'+note+'</span>';
    return h;
  }
  function paintLinePrices(cart,cdaTotal){
    var basis=cart.items_subtotal_price||0;
    if(!cdaTotal || !basis) return;
    var factor=cdaTotal/basis;
    (cart.items||[]).forEach(function(it){
      var row=root.querySelector('.WI_cartDrawer_item[data-itemkey="'+it.key+'"]');
      if(!row) return;
      var p=row.querySelector('.WI_cartDrawer_item_price p'); if(!p) return;
      var effUnit=Math.round(it.final_price*(1-factor));
      var html='<span style="text-decoration:line-through;color:rgba(0,0,0,.6);font-size:calc(var(--wi-pfs) - 1px);">'+eur(it.original_price)+'</span> <span style="color:#1a7f37;font-weight:600;">'+eur(effUnit)+'</span>';
      if(p.getAttribute('data-wi-painted')!==String(effUnit)){ p.innerHTML=html; p.setAttribute('data-wi-painted',String(effUnit)); }
    });
  }
  async function renderDiscountUI(){
    if(renderBusy) return; renderBusy=true;
    try{
      var footer=root.querySelector('.WI_cartDrawerin_cart_footer');
      if(!footer){ renderBusy=false; return; }
      var cart=await wiCartJson(); if(!cart){ renderBusy=false; return; }
      if(await cleanSentinels(cart)){ cart=await wiCartJson()||cart; document.dispatchEvent(new CustomEvent('updateCart',{bubbles:true})); }
      var dcs=(cart.discount_codes||[]).filter(function(d){return !isSentinel(d.code);});
      var cartCodes=wiCodesOf(cart);
      var pend=pendingCode().toUpperCase();
      var pendShow = pend && cartCodes.indexOf(pend)<0;
      var cdas=(cart.cart_level_discount_applications||[]).filter(function(a){return (a.total_allocated_amount||0)>0;});
      var cdaTotal=cdas.reduce(function(s,a){return s+(a.total_allocated_amount||0);},0);
      var desired={};
      dcs.forEach(function(d){ desired[(d.code||'').toUpperCase()]=1; });
      if(pendShow) desired[pend]=1;
      var domHas={};
      footer.querySelectorAll('.WI_discountRemove').forEach(function(b){ domHas[(b.getAttribute('data-code')||'').toUpperCase()]=1; });
      var chipsMatch = Object.keys(desired).length===Object.keys(domHas).length && Object.keys(desired).every(function(k){return domHas[k];});
      var rowsMatch = footer.querySelectorAll('.WI_cartDrawer_saving[data-wi-js]').length===cdas.length;
      if(chipsMatch && rowsMatch){ paintLinePrices(cart,cdaTotal); renderBusy=false; return; }
      footer.querySelectorAll('[data-wi-js]').forEach(function(n){ n.remove(); });
      var container=footer.querySelector('.WI_discountApplied');
      var shown={};
      if(container){ container.querySelectorAll('.WI_discountRemove').forEach(function(b){ shown[(b.getAttribute('data-code')||'').toUpperCase()]=1; }); }
      var html='';
      dcs.forEach(function(d){
        var code=(d.code||'').toUpperCase(); if(shown[code]) return;
        if(d.applicable===false) html+=chipHTML(code,'warn','Code '+code+' gilt noch nicht für diesen Warenkorb');
        else html+=chipHTML(code,'ok');
        shown[code]=1;
      });
      if(pendShow && !shown[pend]) html+=chipHTML(pend,'warn','Wird an der Kasse angewendet',true);
      if(html){
        if(!container){
          container=document.createElement('div');
          container.className='WI_discountApplied';
          container.setAttribute('data-wi-js','1');
          footer.insertBefore(container,footer.firstChild);
        }
        container.insertAdjacentHTML('beforeend',html);
      }
      var totalEl=footer.querySelector('.WI_cartDrawer_total');
      if(totalEl && cdas.length){
        cdas.forEach(function(a){
          var row=document.createElement('div');
          row.className='WI_cartDrawer_saving';
          row.setAttribute('data-wi-js','1');
          row.innerHTML='<span>✓ '+(a.title||'Rabatt')+'</span><span>−'+eur(a.total_allocated_amount)+'</span>';
          totalEl.parentNode.insertBefore(row,totalEl);
        });
      }
      paintLinePrices(cart,cdaTotal);
    }catch(e){ console.log('[WI] discount render',e); }
    renderBusy=false;
  }
  function scheduleRender(ms){ setTimeout(renderDiscountUI, ms||400); }
  document.addEventListener('click', async function(e){
    if(!e.target.closest('.WI_discountApply')) return;
    var btn=e.target.closest('.WI_discountApply');
    var inp=document.querySelector('.WI_discountInput'); var code=normCode(inp&&inp.value); if(!code) return;
    btn.classList.add('is-loading'); wiMsg('');
    var res=await wiApplyDiscount(code);
    btn.classList.remove('is-loading');
    if(res.ok && res.applicable===true){ wiMsg('✓ Code „'+code+'“ angewendet','is-ok'); if(inp) inp.value=''; }
    else if(res.ok && res.applicable===false){ wiMsg('Code „'+code+'“ gilt nicht für diesen Warenkorb','is-err'); }
    else if(res.ok){ wiMsg('✓ Code „'+code+'“ wird an der Kasse angewendet','is-ok'); if(inp) inp.value=''; }
    else{ wiMsg('Code konnte nicht angewendet werden','is-err'); }
    document.dispatchEvent(new CustomEvent('updateCart',{bubbles:true}));
    scheduleRender(800);
  });
  document.addEventListener('keydown', function(e){
    if(e.key==='Enter' && e.target.closest('.WI_discountInput')){ e.preventDefault(); var b=document.querySelector('.WI_discountApply'); if(b) b.click(); }
  });
  document.addEventListener('click', async function(e){
    var b=e.target.closest('.WI_discountRemove'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    var code=(b.getAttribute('data-code')||'').toUpperCase();
    if(b.hasAttribute('data-pending')){ clearPending(code); renderDiscountUI(); return; }
    try{
      var c=await wiCartJson();
      var rest=wiCodesOf(c).filter(function(x){return x!==code;});
      await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:rest.join(',')})});
      clearPending(code);
      document.dispatchEvent(new CustomEvent('updateCart',{bubbles:true}));
      scheduleRender(800);
    }catch(err){ console.log('[WI] discount remove',err); }
  });
  (function(){
    var fromUrl=normCode(new URLSearchParams(location.search).get('discount'));
    if(fromUrl){ try{ sessionStorage.setItem('wi_dc',fromUrl); }catch(e){} }
    else { try{ if(!normCode(sessionStorage.getItem('wi_dc'))) sessionStorage.removeItem('wi_dc'); }catch(e){} }
    var tries=0, busyDc=false;
    function setBanner(txt){ var banner=root.querySelector('#WI_discountBanner'); if(!banner) return; if(!txt){ banner.hidden=true; return; } banner.querySelector('.WI_discountBanner_txt').textContent=txt; banner.hidden=false; }
    async function ensureApplied(){
      var pend=pendingCode(); if(!pend) { setBanner(''); return; }
      if(busyDc||tries>6) return; busyDc=true; tries++;
      try{
        var c=await wiCartJson(); if(!c){ busyDc=false; return; }
        if(wiCodesOf(c).indexOf(pend.toUpperCase())>-1){ setBanner(''); busyDc=false; return; }
        if(!c.item_count){ setBanner('Rabattcode „'+pend+'“ aktiv – wird automatisch angewendet'); busyDc=false; return; }
        var res=await wiApplyDiscount(pend);
        if(res.ok){ setBanner(''); document.dispatchEvent(new CustomEvent('updateCart',{bubbles:true})); scheduleRender(800); }
      }catch(e){}
      busyDc=false;
    }
    if(pendingCode()) setBanner('Rabattcode „'+pendingCode()+'“ aktiv – wird automatisch angewendet');
    ensureApplied();
    document.addEventListener('opencart', function(){ setTimeout(ensureApplied,300); });
    document.addEventListener('updateCart', function(){ setTimeout(ensureApplied,600); });
  })();
  document.addEventListener('opencart', function(){ scheduleRender(500); });
  document.addEventListener('updateCart', function(){ scheduleRender(900); });
  var t;
  new MutationObserver(function(){ clearTimeout(t); t=setTimeout(renderDiscountUI,450); }).observe(root,{childList:true,subtree:true});
  setInterval(function(){ if(root.style.display && root.style.display!=='none') renderDiscountUI(); },2000);
  renderDiscountUI();
})();